import React from "react";

export default function Title({ text }) {
  return (
    <div className="my-3">
      <p className="text-blue-900 font-bold opacity-90  text-sm">{text}</p>
    </div>
  );
}
